/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:50:36
 * @LastEditTime: 2023-03-02 13:47:58
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-statistic-analy\index.js
 * 流向数据分析路由
 */
import agentFlowDimensionRouter from './modules/agentFlowDimensionRouter'
import businessFlowDimensionRouter from './modules/businessFlowDimensionRouter'
import companyFlowStatisRouter from './modules/companyFlowStatisRouter'
import earlyWarningStatisRouter from './modules/earlyWarningStatisRouter'
import priceAnalyRouter from './modules/priceAnalyRouter'
import serviceFlowDimensionRouter from './modules/serviceFlowDimensionRouter'
import summaryFlowStatisRouter from './modules/summaryFlowStatisRouter'
import TerminalflowDimensionRouter from './modules/TerminalflowDimensionRouter'
const flowStatisticAnalyRouter = [].concat(
  agentFlowDimensionRouter,
  businessFlowDimensionRouter,
  companyFlowStatisRouter,
  earlyWarningStatisRouter,
  priceAnalyRouter,
  serviceFlowDimensionRouter,
  summaryFlowStatisRouter,
  TerminalflowDimensionRouter,
)

export default flowStatisticAnalyRouter
